export default [
    //进销存资料-生产车间
    {
        path: "/production",
        name: "production",
        component: () => import("@/views/inventoryData/production.vue"),
        meta: {
            noNeedCheckLogin: true,
        },
    },
       //进销存资料-产品类型
       {
        path: "/productType",
        name: "productType",
        component: () => import("@/views/inventoryData/productType.vue"),
        meta: {
            noNeedCheckLogin: true,
        },
    },
    //进销存资料-产品信息
    {
        path: "/producMation",
        name: "producMation",
        component: () => import("@/views/inventoryData/producMation.vue"),
        meta: {
            noNeedCheckLogin: true,
        },
    },
    //进销存资料-存货仓库
    {
        path: "/warehouse",
        name: "warehouse",
        component: () => import("@/views/inventoryData/warehouse.vue"),
        meta: {
            noNeedCheckLogin: true,
        },
    },
    //进销存资料-物料信息
    {
        path: "/materInfor",
        name: "materInfor",
        component: () => import("@/views/inventoryData/materInfor.vue"),
        meta: {
            noNeedCheckLogin: true,
        },
    },
    //进销存资料-推广单位
    {
        path: "/promoUnit",
        name: "promoUnit",
        component: () => import("@/views/inventoryData/promoUnit.vue"),
        meta: {
            noNeedCheckLogin: true,
        },
    },
]